"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EntityBuilder_1 = require("./EntityBuilder");
var storage_1 = require("./support/storage");
var StringHelper_1 = require("./support/StringHelper");
var Entity = (function () {
    function Entity() {
    }
    Entity.jsonParseAsync = function (sourceObject, jsonObject) {
        return __awaiter(this, void 0, void 0, function () {
            var obj, _a, _b, _i, key, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        obj = Entity.jsonParse(sourceObject, jsonObject, true);
                        _a = [];
                        for (_b in obj)
                            _a.push(_b);
                        _i = 0;
                        _e.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3, 4];
                        key = _a[_i];
                        if (!obj.hasOwnProperty(key)) return [3, 3];
                        _c = obj;
                        _d = key;
                        return [4, obj[key]];
                    case 2:
                        _c[_d] = _e.sent();
                        _e.label = 3;
                    case 3:
                        _i++;
                        return [3, 1];
                    case 4: return [2, obj];
                }
            });
        });
    };
    Entity.jsonParse = function (sourceObject, jsonObject, async) {
        if (async === void 0) { async = false; }
        for (var key in jsonObject) {
            if (jsonObject.hasOwnProperty(key)) {
                var metadata = storage_1.defaultMetadataStorage.findTypeMetadata(sourceObject.constructor, key);
                var value = jsonObject[key];
                if (value !== null && typeof value === 'object' && !(value instanceof Array)) {
                    if (metadata) {
                        sourceObject[metadata.propertyName] = async
                            ? EntityBuilder_1.EntityBuilder.buildOneAsync(metadata.type, value)
                            : EntityBuilder_1.EntityBuilder.buildOne(metadata.type, value);
                    }
                    continue;
                }
                if (value instanceof Array && value.length > 0 && typeof value[0] === 'object') {
                    if (metadata) {
                        sourceObject[metadata.propertyName] = async
                            ? EntityBuilder_1.EntityBuilder.buildManyAsync(metadata.type, value)
                            : EntityBuilder_1.EntityBuilder.buildMany(metadata.type, value);
                    }
                    continue;
                }
                if (metadata) {
                    sourceObject[metadata.propertyName] = value;
                    continue;
                }
                key = EntityBuilder_1.EntityBuilder.enableCamelConversion ? StringHelper_1.StringHelper.toCamel(key) : key;
                if (sourceObject.hasOwnProperty(key)) {
                    sourceObject[key] = value;
                }
                var defaultValueCallback = storage_1.defaultMetadataStorage.findCallback(sourceObject.constructor, key);
                if (defaultValueCallback && defaultValueCallback.condition(sourceObject[key])) {
                    sourceObject[key] = defaultValueCallback.callback();
                }
            }
        }
        return sourceObject;
    };
    Entity.prototype.fromJson = function (jsonData) {
        return Entity.jsonParse(this, jsonData);
    };
    Entity.prototype.fromJsonAsync = function (jsonData) {
        return Entity.jsonParseAsync(this, jsonData);
    };
    Entity.prototype.toJson = function (toSnake, asString) {
        if (toSnake === void 0) { toSnake = true; }
        if (asString === void 0) { asString = false; }
        var data = {};
        for (var key in this) {
            if (!this.hasOwnProperty(key)) {
                continue;
            }
            var outputKey = toSnake ? StringHelper_1.StringHelper.toSnake(key) : key;
            var value = this[key];
            if (value instanceof Entity) {
                data[outputKey] = value.toJson(toSnake, asString);
                continue;
            }
            var metadata = storage_1.defaultMetadataStorage.findTypeMetadata(this.constructor, key);
            if (value instanceof Array && value.length > 0 && value[0] instanceof Object) {
                if (value[0] instanceof Entity) {
                    data[outputKey] = value.map(function (entity) { return entity.toJson(toSnake, asString); });
                }
                if (metadata && metadata.type === Object) {
                    data[outputKey] = value;
                }
                continue;
            }
            if (value !== null && typeof value === 'object' && !(value instanceof Array)) {
                if (metadata && metadata.type === Object) {
                    data[outputKey] = value;
                }
                continue;
            }
            data[outputKey] = value;
        }
        return asString ? JSON.stringify(data) : data;
    };
    return Entity;
}());
exports.Entity = Entity;
//# sourceMappingURL=Entity.js.map